import axios from "axios";
import { getCookie } from "../../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const submitProductAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `products`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const updateProductStatusApi = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `products/status_update/` + id, body, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error updating customer status:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const updateProductAPI = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `products/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getProductEditApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `products/get/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getProductListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `products`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const deleteProductApi = async (id) => {
  try {
    const response = await axios.delete(apiUrl + `products/delete/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const addProductAttachmentApi = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `products/attachment/` + id, body, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error adding attachment:", err);
  }
};
